import { render, staticRenderFns } from "./tesigncontract.vue?vue&type=template&id=5c824d1b&"
import script from "./tesigncontract.vue?vue&type=script&lang=js&"
export * from "./tesigncontract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports